<template>
    <div class="nav-bar">
        <div
            v-if="isEnableAppMenu"
            class="nav-bar--app-menu"
            :class="{'is-active': showAppMenu}"
            @click="handleAppMenuBtnClick"
        ></div>

        <div class="nav-bar--logo" @click="handleLogoClick">
            <img class="logo" :src="logoImageURL" />
        </div>

        <div class="nav-bar--title flex_content_vertical_center" style="font-size: 16px;">{{title}}</div>

        <div class="nav-bar--right">
            <div class="nav-bar--menu">
                <template v-if="isEnableMenu">
                    <el-menu class="el-menu-demo" mode="horizontal">
                        <template v-for="(item,index) in currentMenuItems">
                            <template v-if="!item.IsNest">
                                <el-menu-item
                                    :key="index"
                                    :index="item.vueKey"
                                    @click="menuItemClick(item)"
                                >{{item.Title}}</el-menu-item>
                            </template>
                            <template v-if="item.IsNest">
                                <el-submenu :index="item.vueKey" :key="index" class="noneArrow">
                                    <template slot="title">{{item.Title}}</template>
                                    <nav-bar-menu
                                        :currentMenuItem="item"
                                        @menu-item-click="menuItemClick"
                                    ></nav-bar-menu>
                                </el-submenu>
                            </template>
                        </template>
                        <el-submenu v-if="moreMenuItems.length > 0" :index="'more'">
                            <template slot="title">更多</template>
                            <template v-for="(item,index) in moreMenuItems">
                                <template v-if="!item.IsNest">
                                    <el-menu-item
                                        :key="index"
                                        :index="item.vueKey"
                                        @click="menuItemClick(item)"
                                    >{{item.Title}}</el-menu-item>
                                </template>
                                <template v-if="item.IsNest">
                                    <el-submenu :index="item.vueKey" :key="index">
                                        <template slot="title">{{item.Title}}</template>
                                        <nav-bar-menu
                                            :currentMenuItem="item"
                                            @menu-item-click="menuItemClick"
                                        ></nav-bar-menu>
                                    </el-submenu>
                                </template>
                            </template>
                        </el-submenu>
                    </el-menu>
                </template>
            </div>

            <div v-if="$store.state.NavBarBackHomeButton" class="hover-view" @click="backHome()">
                <span style="padding: 0 15px">返回首页</span>
            </div>

            <div v-if="$store.state.NavBarBackButton" class="hover-view" @click="$router.go(-1)">
                <span style="padding: 0 15px">返回</span>
            </div>

            <div style="display:flex;align-items:center;justify-content: center;height:100%;">
                <el-dropdown
                    v-if="!previewMode"
                    class="nav-bar--user hover-view"
                    trigger="click"
                    @command="$emit('user-setting-click', $event)"
                >
                    <div
                        style="height: 100%;width: 100%;display:flex;align-items:center;padding: 0 15px;"
                        class="dropdown-title"
                    >
                        <span>{{ getUserName() }}</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            class="nav-bar-dropdown-menu-item"
                            command="personalprofile"
                        >个人资料</el-dropdown-item>
                        <el-dropdown-item
                            class="nav-bar-dropdown-menu-item"
                            v-if="getMemoRandumPermissions()"
                            command="memorandum"
                        >个人备忘录</el-dropdown-item>
                        <el-dropdown-item
                            class="nav-bar-dropdown-menu-item"
                            command="changepassword"
                        >修改密码</el-dropdown-item>
                        <el-dropdown-item class="nav-bar-dropdown-menu-item" command="anency">委托代理</el-dropdown-item>
                        <el-dropdown-item
                            class="nav-bar-dropdown-menu-item"
                            command="enterbackstage"
                        >进入后台</el-dropdown-item>
                        <el-dropdown-item
                            class="nav-bar-dropdown-menu-item"
                            divided
                            command="logoff"
                        >退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div v-else class="nav-bar--user">
                    <div
                        style="height: 100%;width: 100%;display:flex;align-items:center;padding: 0 15px;"
                        class="dropdown-title"
                    >
                        <span>{{ getUserName() }}</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginService from '@/services/login.service.js';
import systemService from '../../services/system-service';
import NavMenuType from '@/models/nav-menu-type.enum.js';
import { CreateUUID, IsNull } from '../../utils/utils';
import NavBarMenu from '@/components/common/nav-bar-menu.vue';

export default {
    name: 'nav-bar',

    props: {
        previewMode: {
            type: Boolean,
            default: false,
        },
        isEnableAppMenu: {
            type: Boolean,
            default: true,
        },
        showAppMenu: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        isEnableMenu: {
            type: Boolean,
            default: false,
        },
        menuItems: {
            type: Array,
            default() {
                return [];
            },
        },
        isEnableLogoClick: {
            type: Boolean,
            default: true,
        },
        showBackButton: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        NavBarMenu,
    },

    data() {
        return {
            logoImageURL: null,
            currentMenuItems: [],
            moreMenuItems: [],
            navMenuItems: [],
        };
    },

    computed: {
        matchRoutePathMenuItem() {
            if (Array.isArray(this.currentMenuItems) && this.currentMenuItems.length > 0) {
                const path = `${this.$webURL}${this.$route.fullPath}`;
                const items = this.currentMenuItems
                    .filter(item => {
                        return !IsNull(item.WebURL) && path.indexOf(item.WebURL) !== -1;
                    })
                    .sort((item1, item2) => {
                        const length1 = IsNull(item1.WebURL) ? 0 : item1.WebURL.length;
                        const length2 = IsNull(item2.WebURL) ? 0 : item2.WebURL.length;
                        return length2 - length1;
                    });
                if (items.length > 0 && !IsNull(items[0].WebURL) && items[0].WebURL.length > 0) {
                    return items[0];
                }
                return null;
            } else {
                return null;
            }
        },
    },

    watch: {
        menuItems: {
            handler(val) {
                this.navMenuItems = Array.isArray(val) ? val : [];
                this.navMenuItems = this.initItems(this.navMenuItems);
                if (this.navMenuItems.length > 7) {
                    this.currentMenuItems = this.navMenuItems.slice(0, 6);
                    this.moreMenuItems = this.navMenuItems.slice(6);
                } else {
                    this.currentMenuItems = this.navMenuItems;
                    this.moreMenuItems = [];
                }
            },
        },
    },

    mounted: function() {
        this.getLogoImageURL();
    },

    methods: {
        initItems(items) {
            return items.map(menu => {
                menu.vueKey = CreateUUID();
                if (menu.IsNest) {
                    menu.Children = this.initItems(menu.Children);
                }
                return menu;
            });
        },
        handleAppMenuBtnClick() {
            if (this.previewMode) return;
            this.$emit('update:showAppMenu', !this.showAppMenu);
        },

        handleMoreMenuClick(key) {
            const menuItem = this.moreMenuItems.find(item => item.vueKey === key);
            if (menuItem) {
                this.$emit('menu-item-click', menuItem);
            }
        },

        getLogoImageURL() {
            systemService.getLogoImage().then(logoImageURL => {
                this.logoImageURL = logoImageURL;
            });
        },

        menuIsActive(menuItem) {
            switch (menuItem.Type) {
                case NavMenuType.CurrentlyPage:
                case NavMenuType.NewPage:
                    return this.matchRoutePathMenuItem === menuItem;
                case NavMenuType.MainPage:
                    return this.$route.name === 'home';

                default:
                    return false;
            }
        },

        getMemoRandumPermissions() {
            return loginService.userInfo.MemoRandum;
        },

        getUserName() {
            return loginService.userInfo.Name;
        },

        handleLogoClick() {
            if (this.isEnableLogoClick) {
                this.$router.push({
                    path: '/',
                });
            }
        },
        backHome() {
            if (this.previewMode) return;
            this.$router.push({ name: 'home' });
        },
        findItem(items, key) {
            let res = null;
            items.forEach(element => {
                if (!element.IsNest && element.vueKey === key) {
                    res = element;
                } else if (element.IsNest) {
                    res = this.findItem(element['Children'], key);
                }
                if (res != null) return res;
            });
            return res;
        },
        menuItemClick(item) {
            this.$emit('menu-item-click', item);
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-bar {
    display: flex;
    position: relative;

    &--app-menu {
        cursor: pointer;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 48px;
        background: url('~@/assets/img/application_top_left_icon.png') center no-repeat;
    }

    &--logo {
        height: 100%;
        display: flex;
        align-items: center;

        .logo {
            display: inline-block;
            padding: 0;
            width: auto;
            max-height: 100%;
            cursor: pointer;
        }
    }

    &--title {
        margin-left: 20px;
        font-size: 20px;
        color: #fff;
    }

    &--right {
        margin-left: 20px;
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .hover-view {
            color: #fff;
            cursor: pointer;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }

    &--menu {
        flex: 1;
        display: flex;
        align-items: center;
        .item {
            cursor: pointer;
            color: white;
            padding: 0 5px;
            border-radius: 4px;
            font-size: 14px;

            &:not(:last-child) {
                margin-right: 10px;
            }
        }
    }

    &--user {
        user-select: none;
        display: flex;
        height: 100%;
        align-items: center;
    }

    .dropdown-title {
        cursor: pointer;
        color: white;
    }
}

.app-list {
    width: 300px;
    position: fixed;
    background: #fff;
    z-index: 9999;
    box-shadow: 5px 8px 10px #ccc;
    margin-top: 0;
    display: flex;
    flex-direction: column;
    padding: 0;
    bottom: 0;
    overflow-y: auto;
}

.mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9999;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}

.slide-fade-enter {
    transform: translateX(-100%);
}

.slide-fade-leave-active {
    transform: translateX(-100%);
}
.el-menu-item{
    padding: 0 10px !important;
}
</style>